import { Control, Controller, FieldErrors, UseFormGetValues } from 'react-hook-form'
import dayjs from '../../../../utils/DayjsUtil'
import { FormReactDatePicker } from '../../../../components/forms/datePicker/FormReactDatePicker'
import { TAutorizacionForm } from '../../models/autorizacionForm.type'
import { AppConstantes } from '../../../../utils/Constantes'

type Props = {
  isPorFechaVencimiento: boolean | undefined
  isAutorizacionIndefinida: boolean | undefined
  calcularFechaCantidad: () => void
  usuarioPermiso?: boolean
  control: Control<TAutorizacionForm>
  errors: FieldErrors<TAutorizacionForm>
  getValues: UseFormGetValues<TAutorizacionForm>
}
export const DatosAutorizacionFormPorVencimiento = ({
  isAutorizacionIndefinida,
  isPorFechaVencimiento,
  calcularFechaCantidad,
  control,
  errors,
  getValues,
  usuarioPermiso,
}: Props) => {
  // Vista/captura de vigencia por fecha de vencimiento.
  // En modo "duracion" se muestra solo la fecha calculada (solo lectura).
  // En modo "fecha" se habilita el datepicker y se recalcula la cantidad (dias) en el padre.
  return (
    <div className='col-12'>
      {/* Campos por vencimiento */}
      <div
        className='col-8 text-center'
        style={isAutorizacionIndefinida || isPorFechaVencimiento ? { display: 'none' } : {}}>
        <div className='col-4 text-center'>
          <label className='form-label fs-4 mb-2'>Fecha de vencimiento</label>
          <h4 className='mt-3 mx-4 text-center'>
            {getValues('fechaVencimiento') !== null
              ? dayjs(getValues('fechaVencimiento')).format(AppConstantes.FORMATO_FECHA)
              : '—'}
          </h4>
        </div>
      </div>
      <div
        className='col-4'
        style={isAutorizacionIndefinida || !isPorFechaVencimiento ? { display: 'none' } : {}}>
        <div className='mb-7 d-flex flex-column'>
          <label className='form-label fs-4'>
            Fecha de vencimiento
            <span className='text-danger'>{isPorFechaVencimiento ? '*' : ''}</span>
          </label>
          <Controller
            control={control}
            name='fechaVencimiento'
            render={({ field: { value, onChange } }) => (
              <FormReactDatePicker
                disabled={!usuarioPermiso}
                minDate={
                  getValues('fechaEmision') ? new Date(getValues('fechaEmision')) : undefined
                }
                required={
                  isAutorizacionIndefinida === true || isPorFechaVencimiento === false
                    ? false
                    : true
                }
                name='fechaVencimiento'
                dateFormat='dd/MMM/yyyy'
                placeholderText='Ej. 22/dic/2022'
                onChange={(e: Date) => {
                  onChange(e)
                  calcularFechaCantidad()
                }}
                isClearable={isPorFechaVencimiento && usuarioPermiso}
                value={value}
                closeOnScroll={false}
              />
            )}
          />
          {errors && errors['fechaVencimiento'] && (
            <p className='text-danger text-end fs-5'>{errors['fechaVencimiento']?.message}</p>
          )}
        </div>
      </div>{' '}
    </div>
  )
}
